<template>
  <div
    class="answers"
    data-toggle="buttons"
    :class="{ opacity: answered.length > 3 }"
  >
    <span role="region" aria-live="polite" class="accessibility-hide-text">
      {{
        (answered.length > 0 ? labels.acessibilityAlertInfo : '')
          | parse({
            INFO: acessibilityAlertInfo,
            ANSWERED_LENGTH: answered.length,
            SURVEY_LIMIT_CHOICES: question.surveyLimitVotes,
            SELECTED_CHOICES: selectedChoices,
            SELECTED_CHOICES_LABELS: selectedChoicesLabels,
          })
      }}
    </span>

    <span role="region" aria-live="polite" class="accessibility-hide-text">
      {{ acessibilityAlertWarning }}
    </span>

    <div
      role="button"
      class="card-wrapper m-2"
      v-for="(answer, idx) in answers"
      :key="`${answer.answer_id}-${idx}`"
      :tabindex="idx + 4"
      @keydown.enter.space="select(answer)"
      :class="{
        active:
          answered.filter(a => a.answer_id === answer.answer_id).length > 0,
      }"
      :aria-pressed="
        answered.filter(a => a.answer_id === answer.answer_id).length > 0
          ? 'true'
          : 'false'
      "
      @click="select(answer)"
    >
      <div class="text">
        <div class="value-icon-container" aria-hidden="true">
          <img
            :title="labels.answerDescription + answer.description"
            :src="imageUrl.replace('$ID$', answer.answer_id)"
            class="value-icon"
          />
        </div>
        <span
          class="accessibility-hide-text"
          :aria-hidden="
            answered.filter(a => a.answer_id === answer.answer_id).length > 0
              ? 'true'
              : 'false'
          "
        >
          {{
            `${answer.text}. ${labels.answerDescription} ${answer.description}`
          }}
        </span>
        <span
          :aria-hidden="
            answered.filter(a => a.answer_id === answer.answer_id).length > 0
              ? 'false'
              : 'true'
          "
        >
          {{ answer.text }}
        </span>
        <i
          :title="labels.answerDescription + answer.description"
          class="material-icons clickable"
          aria-hidden="true"
        >
          help
        </i>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

const props = {
  question: {
    type: Object,
    required: true,
    validator: function(question) {
      if (!Array.isArray(question.answers)) return false
      return true
    },
  },
}

export default {
  props: props,
  data() {
    return {
      acessibilityAlertWarning: '',
      imageUrl: 'https://static.teamculture.com.br/images/culture/$ID$.svg',
    }
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    answered: function() {
      return this.question.answered || []
    },
    answers: function() {
      return this.question.answers || []
    },
    labels() {
      return this.resources.component.checkBoxString
    },
    acessibilityAlertInfo() {
      return this.question.surveyLimitVotes === this.answered.length
        ? this.labels.acessibilityAnswerMaxLimitWarning
        : ''
    },
    selectedChoices() {
      return this.answered.length > 0
        ? this.labels.acessibilitySelectedChoices
        : ''
    },
    selectedChoicesLabels() {
      const hasAnswer = this.answered.length > 0
      const choicesLabels = this.answered.map(a => a.text).join(', ')
      const endSetenceText = hasAnswer ? '.' : ''
      return choicesLabels + endSetenceText
    },
  },
  methods: {
    select(answer) {
      if (
        this.answered.length >= this.question.surveyLimitVotes &&
        this.answered.filter(a => a.answer_id === answer.answer_id).length === 0
      ) {
        this.acessibilityAlertWarning =
          answer.text + ' ' + this.labels.acessibilityAlertWarning
        return
      }
      this.acessibilityAlertWarning = ''
      answer.type = 'multi'
      this.$emit('answer', answer)
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/styles/custom/colors';

.answers {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 80%;

  .card-wrapper {
    font-size: 11pt;
    border-radius: 5px;
    cursor: pointer;
    max-width: 250px;
    min-width: 250px;
    overflow: hidden;
    width: 22%;

    &:hover {
      opacity: 1 !important;
      font-weight: bold;
      box-shadow: 0 3px 6px rgba(83, 92, 145, 0.5);
    }

    .value-icon-container {
      text-align: center;
      margin-left: 5px;
      margin-right: 5px;

      .value-icon {
        height: 60px;
      }
    }

    .text {
      align-items: center;
      border: 1px solid rgba(83, 92, 145, 0.2);
      border-radius: 8px;
      color: var(--gray03);
      display: flex;
      height: 100px;
      justify-content: space-between;
      padding: 6px;
      width: 100%;

      i {
        margin-right: 5px;
      }
    }

    &.active {
      font-weight: bold;
      background-color: map-get($theme-colors, 'gray01');
      border: 0;
    }
  }

  &.opacity .card-wrapper {
    opacity: 0.65;

    &.active {
      opacity: 1;
    }
  }
}
</style>
